import { faCircleInfo, faPlay } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

interface VideoTitleProps {
  title: string;
  overview: string;
}

const VideoTitle: React.FC<VideoTitleProps> = ({ title, overview }) => {
  return (
    <div className="w-full h-full flex flex-col justify-center px-6 md:px-20 animate-fade-in bg-gradient-to-t from-black/60 via-transparent to-transparent">
      <div className="max-w-4xl space-y-6 mt-20 md:mt-0">
        <h1 className="text-4xl md:text-8xl font-black text-white drop-shadow-[0_4px_4px_rgba(0,0,0,0.8)] leading-[1.1] tracking-tight">
          {title}
        </h1>
        <p className="hidden md:block text-lg text-gray-200 line-clamp-3 drop-shadow-xl font-medium max-w-xl leading-relaxed">
          {overview}
        </p>
        <div className="flex items-center space-x-4 pt-4">
          <button className="flex items-center space-x-3 px-10 md:px-12 py-3 bg-white text-black font-black rounded-md hover:bg-white/80 transition-all text-xl shadow-2xl transform active:scale-95">
            <FontAwesomeIcon icon={faPlay} className="text-2xl" />
            <span>Play</span>
          </button>
          <button className="flex items-center space-x-3 px-8 md:px-12 py-3 bg-zinc-500/40 text-white font-bold rounded-md hover:bg-zinc-500/60 transition-all text-xl backdrop-blur-md border border-white/10 shadow-2xl transform active:scale-95">
            <FontAwesomeIcon icon={faCircleInfo} className="text-2xl" />
            <span>More Info</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default VideoTitle;
